import server from '../../public/server/server'
// 公用接口
const publicAPI = {
    uploadFile: server.uploadPath + '/oss/upload', // 上传文件
	version:server.requestPath+'/version/indexUrl',//版本升级
    // areaListTreeNode: server.userRequestPath + '/listTreeNode', // 区域树
    ueditorUpload: server.uploadPath + '/oss/cephLoadUrl', // 富文本上传
    areaListTree: server.requestPath + '/sysArea/subordinateList', // 区域树
    subordinateList: server.requestPath + '/sysArea/subordinateList', // 根据当前区域id获取下级区域列表
    parentAndSameLevelList: server.requestPath + '/sysArea/parentAndSameLevelList', // 根据当前区域id获取下级区域列表
    // 查询编码
    codeAndItem:server.requestPath + '/sysCode/codeAndItem', // 获取所有的code 及其 Item
    queryByCodeValue:server.requestPath + '/sysCode/item/queryByCodeValue', // 获取所有的code 及其 Item

    meetingListTree: server.requestPath + '/sysArea/subordinateMeetingList', // 会议区域树区域树

   //------------------------------IM---------------------------------------
    //群信息管理
    getHistoryGroupMsg: server.requestPath + '/imServer/message/getHistoryGroupMsg', // 查询历史消息，查询比当前时间小的历史消息，向上查
    getChatList: server.requestPath + '/imServer/message/getChatList', // 获取当前用户每一个群组最后的聊天信息列表
    //群组管理
    searchSelfGroup: server.requestPath +'/imServer/searchSelfGroup',//根据用户id获取创建的群信息
    searchAddGroup: server.requestPath +'/imServer/searchAddGroup',//根据用户id获取加入的群信息
    searchGroup: server.requestPath +'/imServer/searchGroup',//查找群
    userInOrOutGroup: server.requestPath +'/imServer/userInOrOutGroup',//用户进群或者被移除出群
    getGroupUserInfo: server.requestPath +'/imServer/getGroupUserInfo',//获取群成员列表
    deleteGroup: server.requestPath +'/imServer/deleteGroup',//解散群
    addGroup: server.requestPath +'/imServer/addGroup',//添加群组
    //会议
    createMeeting: server.visualIntercom +'/videoIntercom/createMeeting',//添加会议
    addOrRemoveMeeting: server.visualIntercom +'/videoIntercom/addOrRemoveMeeting',//加入会议或从会议中退出
    groupUserInfo: server.visualIntercom +'/videoIntercom/getGroupUserInfo',//根据群id获取群成员列表
    historyGroupMsg: server.visualIntercom +'/videoIntercom/getHistoryGroupMsg',//查询历史消息，查询比当前时间小的历史消息，向上查
    userGroupList: server.visualIntercom +'/videoIntercom/getUserGroupList',//获取当前用户的所有的群聊信息 deleted ,false 实时对讲 ，true 历史会议 ，为false时，添加查询日期
    concludeMeeting: server.visualIntercom +'/videoIntercom/deleteGroup',//结束会议
    HistoryGroupMsg: server.visualIntercom +'/videoIntercom/getHistoryGroupMsg',//查看历史记录
	getGroupInfo:server.visualIntercom+'/videoIntercom/getGroupInfo',//获取会议详情
    getReadOrNotRead:server.visualIntercom+'/videoIntercom/getReadOrNotRead',//消息的已读未读查询

    // 视频会议
    getAlarmStream: server.visualIntercom+ '/app/alarm/getAlarmStream', // 通过事件ID 获取播放地址
	//GIS创建会议
	createChat: server.visualIntercom+ '/videoIntercom/createChat', //

	//获取版本号
	getVersion:server.requestPath+'/version/lastVersionByType',//查询最新版本

	//操作日志
	logListPage:server.requestPath+`/log/listPage`,//查询操作日志

}
export default publicAPI
